import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv, StyledI, StyledImg} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint} from '../../../styledComponents/Constants'
import {THREAD_CATEGORY, THREAD_PRIORITY} from '../../../CodeMaster'
import {Box} from '@mui/material'
import {
    getFileExtension,
    getFileIconPath,
    getThreadContributorLabelFromSession,
    NatAsyncCallFunction,
} from '../../common/util/Natutil'
import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {PrimaryStyledButton, SecondaryButton} from '../../../styledComponents/Button'
import {
    DisplayBlockDiv,
    DisplayItemDiv,
    DisplayItemInputLabel,
    DisplayItemTitle,
} from '../../../styledComponents/DisplayItem'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {NatPostBulletinBoardThreadConfirmParams} from './repository/NatPostBulletinBoardThreadConfirm'
import {Messages} from '../../../Messages'
import {HKConstants} from '../../../HKConstants'
import {NatPostBulletinBoardThreadSession} from './repository/NatPostBulletinBoardThreadSession'
import {Location, useLocation} from 'react-router-dom'

function withRouter<P extends object>(
    WrappedComponent: React.ComponentType<P>
): React.FC<P> {
    function RouterWrapper(props: P): JSX.Element {
        const location = useLocation();
        return <WrappedComponent{...props} location={location}/>;
    }

    return RouterWrapper;
}

interface Props {
    bulletinBoardRepo: NatBulletinBoardRepo
    location: Location<NatPostBulletinBoardThreadConfirmParams>
}

interface States {
    isLoadCompleted: boolean
}

class NatResidentBulletinBoardThreadConfirmPage extends Component<Props & ResidentPagePropsSet, States> {
    threadConfirmParamsState: NatPostBulletinBoardThreadConfirmParams | null

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
        }

        const locationState: NatPostBulletinBoardThreadConfirmParams = this.props.location.state
        this.threadConfirmParamsState = (locationState) ? locationState : null

        if (!locationState) {
            window.location.href = `/resident/error`
            return
        }

        this.clickRegisterButton = this.clickRegisterButton.bind(this)
        this.clickBackButton = this.clickBackButton.bind(this)

    }

    async componentDidMount(): Promise<void> {
        this.setState({isLoadCompleted: true})
    }


    async clickRegisterButton(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {

            const ret: Nullable<NatPostBulletinBoardThreadSession> =
                await NatAsyncCallFunction(this.props.bulletinBoardRepo.postBulletinBoardThreadSession.bind(
                    this.props.bulletinBoardRepo), this.props.navigate)

            if (ret) {
                const params = this.threadConfirmParamsState as any;
                const categoryIdToSend = params?.threadConfirmParamsState?.categoryId ??
                    params?.categoryId ??
                    params?.threadConfirmParamsState?.threadConfirmParamsState?.categoryId ??
                    '0';
                this.props.navigate(
                    `/resident/bulletinBoardThreadList/${categoryIdToSend}`,
                    {
                        state: {
                            initialMessage: Messages.INTFR0001.toString(),
                            categoryId: categoryIdToSend,
                            threadConfirmParamsState: params?.threadConfirmParamsState ??
                                params?.threadConfirmParamsState?.threadConfirmParamsState ??
                                params,
                        },
                    },
                );
            }

        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                this.props.navigate(
                    `/resident/error`,
                    {
                        state: {
                            message: errorResponseBody.requestError.message,
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    clickBackButton(): void {
        const params = this.threadConfirmParamsState as any;
        this.props.navigate(
            `/resident/bulletinBoardThreadRegister/${params?.threadConfirmParamsState?.categoryId ??
            params.categoryId ?? '0'}`,
            {
                state: params?.threadConfirmParamsState ??
                    params,
            },
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const images = this.threadConfirmParamsState?.threadImage ?? [];
        const hasImages = images.length > 0;
        const files = this.threadConfirmParamsState?.threadFile ?? [];
        const hasFiles = files.length > 0;
        const title = this.threadConfirmParamsState?.title ?? '未入力';
        const detail = this.threadConfirmParamsState?.detail ?? '';
        const priority = this.threadConfirmParamsState?.priority ?? '';
        return <>
            <ContentsMainTitle><TitleIcon/>情報交換掲示板</ContentsMainTitle>
            <ContentsSubTitleWrapper>
                <ContentsSubTitleInner>
                    {THREAD_CATEGORY.codeToEnumConstants(
                        this.threadConfirmParamsState?.categoryId ?? '0')?.label ?? '未選択'}
                </ContentsSubTitleInner>
            </ContentsSubTitleWrapper>

            <MainContainer>
                <DisplayItemTitle>スレッド作成確認</DisplayItemTitle>
                <BlockSpacer height={'20px'}/>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>タイトル</DisplayItemInputLabel>
                    <DisplayItemDiv>{title}</DisplayItemDiv>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>名前</DisplayItemInputLabel>
                    <DisplayItemDiv>{getThreadContributorLabelFromSession()}</DisplayItemDiv>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>優先度</DisplayItemInputLabel>
                    <DisplayItemDiv>
                        {THREAD_PRIORITY.codeToEnumConstants((priority ?? '0') as unknown as string)?.label}
                    </DisplayItemDiv>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>詳細</DisplayItemInputLabel>
                    <DisplayItemDiv>
                        <div dangerouslySetInnerHTML={{__html: detail}}/>
                    </DisplayItemDiv>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>画像</DisplayItemInputLabel>
                    {hasImages ? (
                        <Box mt={'8px'}>
                            <ImageList>
                                {images.map((threadImage, key) => (
                                    <ImageDiv key={key}>
                                        <ImageImg src={String(threadImage.fileData)} alt={threadImage.fileName}/>
                                    </ImageDiv>
                                ))}
                            </ImageList>
                        </Box>) : (<></>
                    )}
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>ファイル</DisplayItemInputLabel>
                    {hasFiles ? (
                        files.map((threadFile, index) => (
                            <DisplayItemFileDiv key={index}>
                                <FileIcon src={getFileIconPath(getFileExtension(threadFile.fileName))}
                                          alt={threadFile.fileName}/>
                                <DisplayItemFileInfosDiv>
                                    <DisplayItemFileNameDiv>{threadFile.publishFileName ?? threadFile.fileName}
                                    </DisplayItemFileNameDiv>
                                    {threadFile.sortOrder !== undefined && (
                                    <DisplayItemFileSortOrderLabelDiv>
                                        {`並び順　${threadFile.sortOrder}`}
                                    </DisplayItemFileSortOrderLabelDiv>)}
                                </DisplayItemFileInfosDiv>
                            </DisplayItemFileDiv>
                        ))) : (<></>
                    )}
                </DisplayBlockDiv>

            </MainContainer>
            <Box padding={'8px 0 15px 0'}>
                {Messages.INTFC0001.toString(HKConstants.VMN.NTF.THREAD_RETENTION_YEAR)}
            </Box>
            <Box mb={'15px'}>
                <PrimaryStyledButton
                    onClick={this.clickRegisterButton}
                    disabled={false}>
                    スレッドを作成する
                </PrimaryStyledButton>
            </Box>
            <Box mb={'15px'}>
                <SecondaryButton
                    onClick={this.clickBackButton}
                    disabled={false}>
                    修正する
                </SecondaryButton>
            </Box>
        </>
    }
}

export default createResidentPage(withRouter(NatResidentBulletinBoardThreadConfirmPage))

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #4dba78;

  &::before {
    content: "\f111";
  }
`

const DisplayItemFileDiv = styled(DisplayItemDiv)`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const FileIcon: StyledImg = styled.img`
  max-width: 50%;
  ${breakPoint.lessThan('sp')`
    max-width: 150%;
  `}
`

const DisplayItemFileIconDiv = styled(DisplayItemDiv)`
  flex-basis: 20%;
  ${breakPoint.lessThan('sp')`
    margin-left: 0;
  `}
`

const DisplayItemFileNameDiv = styled(DisplayItemDiv)`
  flex-basis: 60%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
    padding-left: 10px;
  `}
`

const DisplayItemFileSortOrderLabelDiv = styled(DisplayItemDiv)`
  flex-basis: 20%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
    padding-left: 10px;
  `}
`

const ImageList: StyledDiv = styled.div`
  width: 100%;
  float: left;
`

const ImageDiv: StyledDiv = styled.div`
  display: inline;
  width: calc(100% / 4);
  padding: 8px;
  box-sizing: border-box;
  float: left;
  ${breakPoint.lessThan('sp')`
    width: 100%;
 `}
`

const ImageImg: StyledImg = styled.img`
  max-width: 100%;
  height: auto;
`

const DisplayItemFileInfosDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center ${breakPoint.lessThan('sp')`
    flex-direction: column;
    padding-left: 10px;
    align-items: flex-start;
  `}
`
